import Layout from "components/layout";
import Questionnaire from "components/questionnaire";

import {
  pageTitle,
  metaDescription,
  canonicalUrl,
  questionPropsFromParams
} from "utils/questions";

export async function getServerSideProps({ res, params }) {
  res.setHeader(
    "Cache-Control",
    "public, max-age=600, stale-while-revalidate=86400"
  );

  try {
    const props = await questionPropsFromParams(params);
    return { props };
  } catch (error) {
    if (error.statusCode !== 404) throw error;
    return { notFound: true };
  }
}

export default function QuestionByExamNumber(props): JSX.Element {
  const { question, links, totalCount, index } = props;

  return (
    <Layout
      title={pageTitle(question)}
      description={metaDescription(question)}
      canonical={canonicalUrl(question)}
      disableTransition={true}
    >
      <main className="md:!p-0 p-0 w-full">
        <Questionnaire
          question={question}
          links={links}
          totalCount={totalCount}
          paginationIndex={index}
        />
      </main>
    </Layout>
  );
}
